import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("omni_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const school = localStorage.getItem("omni_active_school");
  if (school) config.headers["X-School-Id"] = school;
  return config;
});

// A revoked / deactivated session (role change, password change, account turned off) sends the user back to sign in.
api.interceptors.response.use((r) => r, (err) => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 401 && localStorage.getItem("omni_token") && !url.startsWith("/auth/")) {
    localStorage.removeItem("omni_token");
    if (!window.location.pathname.startsWith("/login")) window.location.assign("/login");
  }
  return Promise.reject(err);
});

export default api;
